import BulkUploadBonuses from "../../../views/BulkUploadBonuses.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const BulkUploadBonusesRoutes = [
  {
    menuName: MenuNames.BULK_UPLOAD_BONUSES,
    path: "/bulk-upload-bonuses",
    component: BulkUploadBonuses,
    exact: true,
  },
];

export default BulkUploadBonusesRoutes;
